import React from 'react' 
import { Form, Input, DatePicker, Modal, notification } from 'antd'
import moment from 'moment'
import { withApollo } from 'react-apollo'

import {
    EDIT_USER_TOPIC_ENTRY,
    GET_PAGINATED_USER_TOPICS
} from '../../qql'

import {
    CapitalizeEveryFirstLetter
} from '../../../../functions'

import './EditParticipant.scss'

class EditParticipant extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            error_entry: null
        }

        this.formRef = React.createRef()
    }

    onEditParticipantEntry = (variables) => {
        const { client } = this.props

        client.mutate({
            mutation: EDIT_USER_TOPIC_ENTRY,
            variables: variables,
            // refetchQueries: this.userTopicsRefetcher()
            refetchQueries: [{
                query: GET_PAGINATED_USER_TOPICS,
                variables: {
                  page: this.props.page,
                  pageSize: this.props.page_size
                }
            }]
        }).then(res => {
            if(res.data.editUserTopicEntry) {
                console.log("Edited user entry")
                this.props.activeEntrySetter(null)
                notification.success({
                    message: "User topic entry successfully updated"
                })
            } else {
                console.log("EXISTING ENTRY!")
                this.setState({
                    error_entry: 'Entry already existing'
                })
            }
            
        })
    }

    userTopicsRefetcher = () => {
        const { tableData } = this.props
        const toRefetch = []

        if(tableData) {
            const { getUserTopics } = tableData
            const { pagination } = getUserTopics
            const count = pagination.pageCount + 1

            for (var i = 0; i < count; i++) {
                toRefetch.push({
                    query: GET_PAGINATED_USER_TOPICS,
                    variables:{
                      page: i + 1,
                      pageSize: 10,
                      filter: {
                        search: ''
                      }
                    }
                })
            }

        }

        return toRefetch
    }

    onSubmit = () => {
        this.formRef.current.submit()
    }

    validateFullname = (rule, value, callback) => {
        if(value &&  value.trim() === '') {
            return callback("Please enter your fullname")
        }
    
        callback()
    }

    validateTopic = (rule, value, callback) => {
        if(value &&  value.trim() === '') {
            return callback("Please enter topic")
        }
    
        callback()
    }

    clearError = () => {
        this.setState({
            error_entry: null
        })
    }
    
    render() {
        const { data } = this.props

        const fields = [
            {
                name: ['fullname'],
                value: data? data.fullname : null
            },
            {
                name: ['email_address'],
                value: data? data.email_address : null
            },
            {
                name: ['date_attended'],
                value: data? data.date_attended : null
            },{
                name: ['topic'],
                value: data? data.topic : null
            }
        ]

        return (
            <div className="edit-participant__container">
                <Form 
                    hideRequiredMark
                    labelCol={{
                        span: 7
                    }}
                    labelAlign="left"
                    colon={false}
                    onFinish={e => {
                        const self = this

                        Modal.confirm({
                            title: <p>Are you sure in updating this entry? All entries related to this email address will also be updated. <br/><br/>
                            Continue anyway?</p>,
                            okText: 'Continue',
                            onOk() {
                                self.onEditParticipantEntry({
                                    fullname: e.fullname,
                                    email: e.email_address, 
                                    date_attended: e.date_attended, 
                                    topic: e.topic, 
                                    user_topic_uid: data.user_topic_uid 
                                })
                            }
                        })
                    }}
                    onFinishFailed={e => {
                        // console.log("FAILED: ", e)
                    }}
                    ref={this.formRef}
                    fields={fields}
                    onFieldsChange={(changedFields, allFields) => {
                        // console.log("CHANGEDFIELDS: ", changedFields)
                        // console.log("ALLFIELDS:", allFields)
                        this.props.activeEntrySetter({
                            fullname: allFields[0].value,
                            email_address: allFields[1].value,
                            date_attended: allFields[2].value,
                            topic: allFields[3].value,
                            user_topic_uid: data.user_topic_uid
                        })
                        this.setState({
                            error_entry: null
                        })
                    }}
                >
                    <Form.Item
                        label={<div className="edit-participant__label">Full Name</div>}
                        name='fullname'
                        rules={[
                            { required: true, message: 'Please enter full name' },
                            { validator: this.validateFullname }
                        ]}
                    >
                        <Input
                            placeholder="Please input full name here"
                        />
                    </Form.Item>
                    <Form.Item
                        label={<div className="edit-participant__label">Email Address</div>}
                        name='email_address'
                        rules={[
                            { required: true, message: 'Please enter email address' },
                            { type: 'email', message: 'Please enter a valid email address'}
                        ]}
                    >
                        <Input
                            placeholder="Please input email address here"
                        />
                    </Form.Item>
                    <Form.Item
                        label={<div className="edit-participant__label">Date Attended</div>}
                        name="date_attended"
                        rules={[
                            { required: true, message: 'Please enter date attended' }
                        ]}
                    >
                        <DatePicker/>
                    </Form.Item>
                    <Form.Item
                        label={<div className="edit-participant__label">Topic</div>}
                        name="topic"
                        rules={[
                            { required: true, message: 'Please enter topic' },
                            { validator: this.validateTopic }
                        ]}
                    >
                        <Input
                            placeholder="Please input topic name here"
                        />
                    </Form.Item>
                </Form>
                {this.state.error_entry? 
                    <div className="add-participant__error-div"> 
                        {this.state.error_entry}
                    </div>
                :null}
            </div>
        )
    }
}

export default withApollo(EditParticipant, { withRef: true })